import type {paths} from '../openapi/auth.swagger';
import {axiosInstance} from './axiosInstance';

type LogoutOperation = paths['/executor_web/auth/logout']['delete'];

export type LogoutResponse = LogoutOperation['responses'][200]['content']['application/json'];

/** DELETE `/executor_web/auth/logout` — см. `paths['/executor_web/auth/logout']` в auth swagger */
export function logout(signal?: AbortSignal) {
	return axiosInstance.delete<LogoutResponse>('auth/logout', {signal});
}
